import { useEffect, useState } from "react";

const KEY = "uor_cart_v1";
const listeners = new Set();

const read = () => {
    if (typeof window === "undefined") return [];
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

const write = (items) => {
    localStorage.setItem(KEY, JSON.stringify(items));
    listeners.forEach((l) => l());
};

export const cart = {
    add(slug, qty = 1) {
        const items = read();
        const ex = items.find((i) => i.slug === slug);
        if (ex) ex.qty += qty;
        else items.push({ slug, qty });
        write(items);
    },
    remove(slug) { write(read().filter((i) => i.slug !== slug)); },
    setQty(slug, qty) {
        const items = read().map((i) => (i.slug === slug ? { ...i, qty: Math.max(1, qty) } : i));
        write(items);
    },
    clear() { write([]); },
    get() { return read(); },
};

export function useCart() {
    const [items, setItems] = useState(read());
    useEffect(() => {
        setItems(read());
        const cb = () => setItems(read());
        listeners.add(cb);
        return () => { listeners.delete(cb); };
    }, []);
    return items;
}
